/** Static catalog of policy-gated MCP connectors that an admin can activate
 *  per tenant. This is the single source of truth for the admin console's
 *  connector picker (labels + platform tags) and the only valid ids that may
 *  be written into a tenant's `active_mcp_connectors` allowlist.
 *
 *  The runtime connector id (`HWP_OPERATE_CONNECTOR_ID` in the desktop's
 *  mcp-descriptor-loader) MUST match the catalog id exactly — the entitlement
 *  gate compares by exact string, so any drift silently disables the gate.
 *  A unit test pins this invariant. */
export interface McpConnectorCatalogEntry {
  id: string;
  label: string;
  platform?: 'win32' | 'darwin' | 'all';
}

/** Canonical connector ids. Every module that names a connector — policy gates,
 *  skill-overlap maps, orientation registries, capability-lease specs, the
 *  desktop tool servers — MUST import these instead of re-typing the literal, so
 *  the entitlement gate (exact-string compare) can never drift silently. */
export const HWP_OPERATE_CONNECTOR_ID = 'HWP_Operate';
/** Retired (the parked Excel extension app). Not in the catalog below: it is
 *  kept only so retired-id handling (`RETIRED_LOCAL_EXTENSIONS`) and historical
 *  tool records can name it. */
export const EXCEL_OPERATE_CONNECTOR_ID = 'Excel_Operate';

export const MCP_CONNECTOR_CATALOG: McpConnectorCatalogEntry[] = [
  { id: HWP_OPERATE_CONNECTOR_ID, label: '한컴 한글 확장 번들 (HWP)', platform: 'win32' }
];

export const MCP_CONNECTOR_IDS: string[] = MCP_CONNECTOR_CATALOG.map((connector) => connector.id);
